/**
 * V167 — Homepage Manifesto Banner
 *
 * Compact strip rendered above HomepageLossHero. Delivers the manifest
 * war-cry without replacing existing conversion machinery, then funnels
 * curious visitors to the full /manifest cold-traffic page.
 */
import { Link } from "react-router-dom";
import { ArrowRight, Skull } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";

const HEADLINES = {
  sk: { kicker: "SEO nástroje sú mŕtve.", continuation: "Najmi agentov, ktorí robia prácu.", cta: "Prečítaj manifest" },
  en: { kicker: "SEO tools are dead.", continuation: "Hire agents that do the work.", cta: "Read the manifesto" },
  de: { kicker: "SEO-Tools sind tot.", continuation: "Stelle Agenten ein, die die Arbeit machen.", cta: "Manifest lesen" },
  pl: { kicker: "Narzędzia SEO są martwe.", continuation: "Zatrudnij agentów, którzy wykonują pracę.", cta: "Przeczytaj manifest" },
  hu: { kicker: "Az SEO eszközök meghaltak.", continuation: "Vegyél fel ügynököket, akik dolgoznak.", cta: "Olvasd a kiáltványt" },
  cs: { kicker: "SEO nástroje jsou mrtvé.", continuation: "Najmi agenty, kteří dělají práci.", cta: "Přečti manifest" },
};

export default function HomepageManifestoBanner() {
  const { language } = useLanguage();
  const h = HEADLINES[language] || HEADLINES.en;

  return (
    <Link
      to="/manifest"
      data-testid="homepage-manifesto-banner"
      className="group block bg-black border-y border-red-500/30 relative overflow-hidden"
    >
      {/* subtle red glow */}
      <div className="absolute inset-0 bg-gradient-to-r from-red-500/10 via-transparent to-red-500/10 opacity-50 group-hover:opacity-100 transition-opacity"/>
      <div className="relative max-w-6xl mx-auto px-6 py-5 sm:py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="flex items-center gap-3 sm:gap-4 text-center sm:text-left">
          <div className="hidden sm:flex w-10 h-10 rounded-full bg-red-500/15 border border-red-500/40 items-center justify-center shrink-0">
            <Skull className="w-5 h-5 text-red-400"/>
          </div>
          <div>
            <div className="text-base sm:text-lg font-black tracking-tight">
              <span className="text-red-400">{h.kicker}</span>{" "}
              <span className="text-white/80">{h.continuation}</span>
            </div>
            <div className="text-[10px] text-white/40 font-mono uppercase tracking-widest mt-0.5">TopRankPulse Manifesto</div>
          </div>
        </div>
        <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white text-black text-xs font-black uppercase tracking-wider group-hover:bg-red-400 group-hover:text-white transition-colors shrink-0">
          {h.cta} <ArrowRight className="w-3.5 h-3.5"/>
        </span>
      </div>
    </Link>
  );
}
